import { render, staticRenderFns } from "./PayrollProvisions.vue?vue&type=template&id=ef5c6648"
import script from "./PayrollProvisions.vue?vue&type=script&lang=js"
export * from "./PayrollProvisions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports